<p>ob-dashboard works!</p>
